import { render, staticRenderFns } from "./ShopImagesAlbumField.vue?vue&type=template&id=dff082f8&scoped=true"
import script from "./ShopImagesAlbumField.vue?vue&type=script&lang=ts"
export * from "./ShopImagesAlbumField.vue?vue&type=script&lang=ts"
import style0 from "./ShopImagesAlbumField.vue?vue&type=style&index=0&id=dff082f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff082f8",
  null
  
)

export default component.exports